import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, map, Observable } from 'rxjs';
import { Coordinates } from '../entities/coordinates.model';
import { CreneauInterPonctuelle } from '../entities/creneaux/creneau-inter-ponctuelle.model';
import { CompteMobileAProximite } from '../entities/demande/compte-mobile-a-proximite.model';
import { InterPonctuelleForResponsableDTO } from '../entities/demande/inter-ponctuelle-for-responsable.dto';
import { MotifRefus } from '../entities/demande/motif-refus.model';
import { ServerUrl } from './server-url.service';

@Injectable({
  providedIn: 'root',
})
export class DemandesService {
  private readonly prefix: string = '/me';

  constructor(
    private readonly http: HttpClient,
    private readonly serverUrl: ServerUrl
  ) {}

  public affecterDemande(idDemande: string, idCompteMobile: string): Observable<void> {
    return this.http.post<void>(this.serverUrl.get() + `/../api/demande/${idDemande}/affecter`, { idDemande, idCompteMobile });
  }

  public getComptesMobilesByDistance(location: Coordinates): Observable<CompteMobileAProximite[]> {
    const params = new HttpParams().set('latitude', location.latitude).set('longitude', location.longitude);
    return this.http.get<CompteMobileAProximite[]>(this.serverUrl.get() + this.prefix + '/agents/distanceof', { params });
  }

  public accepterDemande(demande: CreneauInterPonctuelle | { id: string }): Promise<void> {
    return firstValueFrom(this.http.put<void>(this.serverUrl.get() + `/../api/demande/${demande.id}/accepte`, null));
  }

  public refuserDemandeAvecMotif(demande: CreneauInterPonctuelle, motif: MotifRefus): Promise<void> {
    const body = {
      motifId: motif.id,
    };
    return firstValueFrom(this.http.post<void>(this.serverUrl.get() + `/../api/demande/${demande.id}/refuse`, body));
  }

  public refuserDemandeAutre(demande: CreneauInterPonctuelle, raison: string): Promise<void> {
    const body = { raison };
    return firstValueFrom(this.http.post<void>(this.serverUrl.get() + `/../api/demande/${demande.id}/refuse`, body));
  }

  public getMotifsRefus(): Observable<MotifRefus[]> {
    return this.http.get<MotifRefus[]>(this.serverUrl.get() + `/../api/prestations/motif-refus`);
  }

  public quitterImmediatement(demande: CreneauInterPonctuelle): Promise<void> {
    return firstValueFrom(this.http.post<void>(this.serverUrl.get() + `/../api/demande/${demande.id}/quitter`, null));
  }

  public refuserResponsable(demande: InterPonctuelleForResponsableDTO, raison: string): Promise<void> {
    const body = { raison };
    return firstValueFrom(this.http.post<void>(this.serverUrl.get() + `/../api/demande/${demande.prestationId}/decline`, body));
  }

  public getDemandesATraiter(): Observable<InterPonctuelleForResponsableDTO[]> {
    return this.http
      .get<InterPonctuelleForResponsableDTO[]>(this.serverUrl.get() + this.prefix + '/demandes')
      .pipe(map(demandes => demandes.map(demande => InterPonctuelleForResponsableDTO.hydrate(demande))));
  }
}
